<template>
    <PageContentLoader v-if="fetchingOrStale && !ring" />

    <PageErrorFiveHundred
        v-else-if="error"
        :errors="responseErrors"
    >
        <!-- TODO What if this error is in another query-->
        <ThButton
            :loading="fetchingOrStale"
            @click="executePageQuery"
        >
            {{ t('globals.try_again') }}
        </ThButton>
    </PageErrorFiveHundred>

    <div v-else-if="ring">
        <ProductBreadcrumbs :breadcrumbs />

        <div
            class="product-wrapper"
            :class="{ fetching }"
        >
            <div v-if="is3rdStep && imageFor3rdStep">
                <Image
                    v-bind="
                        getGenericImageProps({
                            size: imageFor3rdStep.large_x2,
                        })
                    "
                />
            </div>

            <ProductGallery
                v-else
                data-qa="product-gallery"
                :initial-three-sixty-image-index="4"
                :product="ring"
            />

            <div class="product-details">
                <div
                    v-qa="'product-information'"
                    :data-qa-product-properties="
                        JSON.stringify({
                            name: ring.productName,
                            metal: ring.primaryMetal.translation.name,
                            stoneShape:
                                ring.centreStoneConstraints.shape.systemCode,
                            signatureStone:
                                ring.signatureStone?.colors[0]?.systemCode,
                            mountPrice: ring?.salePrice.total || {
                                amount: '0',
                                currency: 'GBP',
                            },
                        })
                    "
                    class="product-information"
                >
                    <div class="product-title">
                        <h1
                            v-qa="'ring-name'"
                            class="name"
                        >
                            {{ ring.productName }}
                        </h1>

                        <SaveForLaterButton
                            v-if="!is3rdStep"
                            :product="ring"
                            :is-p-l-p="false"
                        />
                    </div>

                    <ReviewsAggregate
                        v-if="ring.reviewsAggregate.total"
                        :data="ring.reviewsAggregate"
                        :is3rd-step
                    />

                    <p
                        v-qa="'ring-description'"
                        class="description"
                    >
                        {{ ring.translation.description }}
                    </p>

                    <div
                        v-if="!is3rdStep && totalSalePriceBefore3rdStep"
                        class="price-explained-text"
                    >
                        <TaxSnippet
                            v-if="totalSalePriceBefore3rdStep"
                            :data="totalSalePriceBefore3rdStep"
                        />

                        <div class="price-explained-container">
                            <TooltipCustom>
                                <!-- TODO translate -->
                                <template #label>Price explained</template>

                                <!-- TODO translate -->
                                <template #title>Price explained</template>

                                <!-- TODO translate -->
                                <template #content>
                                    <ul class="price-explainer-list">
                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Ring price
                                            </span>

                                            <span class="value">
                                                <Money
                                                    :data="
                                                        totalSalePriceBefore3rdStep.total
                                                    "
                                                    :formatter
                                                />
                                            </span>
                                        </li>

                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Shipping
                                            </span>

                                            <!-- TODO translate -->
                                            <span class="value">
                                                Free & Insured
                                            </span>
                                        </li>

                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Resizing
                                            </span>

                                            <!-- TODO translate -->
                                            <span class="value">
                                                Complimentary
                                            </span>
                                        </li>

                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Warranty
                                            </span>

                                            <!-- TODO translate -->
                                            <span class="value">
                                                Lifetime
                                            </span>
                                        </li>

                                        <hr class="divider" />

                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Sub-total (choose your centre
                                                stone next)
                                            </span>
                                            <span class="value">
                                                <TaxSnippet
                                                    :data="
                                                        totalSalePriceBefore3rdStep
                                                    "
                                                    :inline="true"
                                                />
                                            </span>
                                        </li>
                                    </ul>
                                </template>
                            </TooltipCustom>

                            <!-- TODO translate -->
                            Note: price excludes centre diamond.
                        </div>
                    </div>

                    <Transition name="step-three">
                        <div
                            v-if="is3rdStep"
                            v-qa="'third-step-container'"
                            :class="classStepThree"
                            class="step-three"
                        >
                            <TaxSnippet
                                v-if="totalSalePrice3rdStep"
                                :data="totalSalePrice3rdStep"
                            />

                            <div class="price-explained-text">
                                <TooltipCustom
                                    v-if="
                                        totalSalePriceBefore3rdStep &&
                                        ringBuilderStone &&
                                        ringBuilderStone.salePrice
                                    "
                                >
                                    <!-- TODO translate -->
                                    <template #label>Price explained</template>

                                    <!-- TODO translate -->
                                    <template #title>Price explained</template>

                                    <!-- TODO translate -->
                                    <template #content>
                                        <ul class="price-explainer-list">
                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Ring price
                                                </span>

                                                <span class="value">
                                                    <Money
                                                        :data="
                                                            totalSalePriceBefore3rdStep.total
                                                        "
                                                        :formatter
                                                    />
                                                </span>
                                            </li>
                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    {{
                                                        ringBuilderStoneTypeLabel
                                                    }}
                                                    price
                                                </span>

                                                <span class="value">
                                                    <Money
                                                        :data="
                                                            ringBuilderStone.salePrice
                                                        "
                                                        :formatter
                                                    />
                                                </span>
                                            </li>

                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Shipping
                                                </span>

                                                <!-- TODO translate -->
                                                <span class="value">
                                                    Free & Insured
                                                </span>
                                            </li>

                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Resizing
                                                </span>

                                                <!-- TODO translate -->
                                                <span class="value">
                                                    Complimentary
                                                </span>
                                            </li>

                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Warranty
                                                </span>

                                                <!-- TODO translate -->
                                                <span class="value">
                                                    Lifetime
                                                </span>
                                            </li>

                                            <hr class="divider" />

                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Sub-total
                                                </span>
                                                <span class="value">
                                                    <TaxSnippet
                                                        v-if="
                                                            totalSalePrice3rdStep
                                                        "
                                                        :data="
                                                            totalSalePrice3rdStep
                                                        "
                                                        :inline="true"
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </template>
                                </TooltipCustom>
                            </div>

                            <FinanceOptions
                                :affirm="ringBuilder.affirmFinanceOptions.value"
                                :klarna="ringBuilder.klarnaFinanceOptions.value"
                            />

                            <!-- TODO translate -->
                            <div
                                class="title"
                                role="heading"
                            >
                                Price includes
                            </div>

                            <div
                                v-qa="'item-ring'"
                                class="item ring"
                            >
                                <Image
                                    v-if="ringBuilderRingImage"
                                    :loading="isMobileAgent ? 'lazy' : 'eager'"
                                    class="image"
                                    fit="contain"
                                    v-bind="
                                        getGenericImageProps({
                                            size: ringBuilderRingImage.small_x2,
                                        })
                                    "
                                />

                                {{ ringBuilderRingDescription }}

                                <div
                                    v-if="!fetchingRingBuilderSetMutation"
                                    class="remove-button"
                                    @click.prevent.stop="removeRing"
                                >
                                    <Icon
                                        class="icon-close"
                                        icon="close"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="ringBuilderStoneImage"
                                v-qa="'item-stone'"
                                class="item stone"
                            >
                                <img
                                    v-if="'url' in ringBuilderStoneImage"
                                    :alt="ringBuilderStoneDescription"
                                    :loading="isMobileAgent ? 'lazy' : 'eager'"
                                    :src="ringBuilderStoneImage.url"
                                    class="image"
                                />
                                <Image
                                    v-else
                                    class="image"
                                    :alt="ringBuilderStoneDescription"
                                    :loading="isMobileAgent ? 'lazy' : 'eager'"
                                    v-bind="ringBuilderStoneImage.image"
                                />

                                <div>
                                    {{ ringBuilderStoneDescription }}

                                    <Icon
                                        class="icon-stone-modal-info"
                                        icon="info"
                                        @click="openStoneModal"
                                    />
                                </div>

                                <component
                                    :is="stoneModalComponent.is"
                                    v-if="
                                        isStoneModalOpened &&
                                        stoneModalComponent
                                    "
                                    v-bind="stoneModalComponent.props"
                                    v-on="stoneModalComponent.events"
                                ></component>

                                <div
                                    v-if="!fetchingRingBuilderSetMutation"
                                    class="remove-button"
                                    @click.prevent.stop="removeStone"
                                >
                                    <Icon
                                        class="icon-close"
                                        icon="close"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="
                                    ringBuilderSignatureStoneImg &&
                                    ringBuilderSignatureStoneDescription
                                "
                                class="item stone signature-stone"
                            >
                                <img
                                    :alt="ringBuilderSignatureStoneDescription"
                                    :loading="isMobileAgent ? 'lazy' : 'eager'"
                                    :src="ringBuilderSignatureStoneImg"
                                    class="image"
                                />

                                {{ ringBuilderSignatureStoneDescription }}

                                <LazyTooltip
                                    inline
                                    path="/engagement-ring/signature-stone"
                                />
                            </div>

                            <div class="size-and-engraving">
                                <ThSelect
                                    v-model="ringSizeId"
                                    v-qa="'ring-size'"
                                    :error="ringSizeError"
                                    :legend="'Ring size'"
                                    :options="ringSizeOptions"
                                    :placeholder="'Select'"
                                    class="size"
                                    serif-font
                                >
                                    <template #tooltip>
                                        <LazyTooltip
                                            inline
                                            path="/engagement-ring/ring-size"
                                        />
                                    </template>
                                </ThSelect>

                                <TextField
                                    id="engraving"
                                    v-model="engraving"
                                    :error="errors.last('engraving')"
                                    :label="'Optional engraving'"
                                    :maxlength="engravingMaxLength"
                                    class="engraving"
                                    serif-font
                                >
                                    <template #tooltip>
                                        <LazyTooltip
                                            inline
                                            path="/engagement-ring/engraving"
                                        />
                                    </template>
                                </TextField>
                            </div>
                        </div>
                    </Transition>
                </div>

                <Transition name="product-customization">
                    <div
                        v-if="!is3rdStep"
                        class="product-customization"
                    >
                        <MetalVariations
                            :selected="ring"
                            :variations="metalVariations"
                        />

                        <div class="product-variation">
                            <span class="label">
                                {{
                                    t(
                                        'catalogue.engagement_ring.product_customization.center_shape'
                                    )
                                }}:
                                {{
                                    ring.centreStoneConstraints.shape
                                        .translation.name
                                }}

                                <button
                                    class="additional-options"
                                    type="button"
                                    @click="togglesEnquireShape"
                                >
                                    {{
                                        t(
                                            'catalogue.engagement_ring.prefer_another_shape.title'
                                        )
                                    }}
                                </button>
                            </span>

                            <ul
                                v-if="!isEnquireShapeOpen"
                                class="shape-variations"
                                data-qa="shape-variations"
                            >
                                <li
                                    v-for="(
                                        variation, variationKey
                                    ) in centreStoneVariations"
                                    :key="variationKey"
                                    class="variation"
                                >
                                    <ThLink
                                        v-qa="
                                            variation.centreStoneConstraints
                                                .shape.systemCode
                                        "
                                        :to="routes.ring.engagement(variation)"
                                        class="link"
                                    >
                                        <img
                                            v-if="
                                                variation.centreStoneConstraints
                                                    .shape.icon
                                            "
                                            :alt="
                                                variation.centreStoneConstraints
                                                    .shape.translation.name
                                            "
                                            :loading="
                                                isMobileAgent ? 'lazy' : 'eager'
                                            "
                                            :src="
                                                variation.centreStoneConstraints
                                                    .shape.icon.url
                                            "
                                            class="image"
                                        />

                                        <span
                                            v-else
                                            class="name"
                                        >
                                            {{
                                                variation.centreStoneConstraints
                                                    .shape.translation.name
                                            }}
                                        </span>
                                    </ThLink>
                                </li>
                            </ul>

                            <div
                                v-else
                                class="enquire-shape"
                            >
                                <span class="title">
                                    {{
                                        t(
                                            'catalogue.engagement_ring.prefer_another_shape.title'
                                        )
                                    }}
                                </span>

                                <p>
                                    {{
                                        t(
                                            'catalogue.engagement_ring.prefer_another_shape.description'
                                        )
                                    }}
                                </p>

                                <ThButton
                                    :loading="fetchingCreateShapeEnquiry"
                                    :text-size="14"
                                    class="th-button"
                                    color="var(--white)"
                                    type="link"
                                    @click="handleShapeEnquiryButton"
                                >
                                    {{
                                        t(
                                            'catalogue.engagement_ring.prefer_another_shape.button'
                                        )
                                    }}
                                </ThButton>

                                <button
                                    class="enquire-shape-close"
                                    type="button"
                                    @click="togglesEnquireShape"
                                >
                                    <Icon icon="close" />
                                </button>
                            </div>
                        </div>

                        <div class="product-variation">
                            <span
                                v-if="signatureStoneLabel"
                                class="label"
                            >
                                {{
                                    t(
                                        'catalogue.engagement_ring.product_customization.signature_stone'
                                    )
                                }}:
                                {{ signatureStoneLabel }}
                                <LazyTooltip
                                    inline
                                    path="/engagement-ring/signature-stone"
                                />
                            </span>

                            <ul
                                class="signature-stone-variations"
                                role="listbox"
                            >
                                <li
                                    v-for="(
                                        { signatureStone: sigStone }, index
                                    ) in ring.signatureStones"
                                    :key="index"
                                    tabindex="0"
                                    :class="
                                        getClassSignatureStoneVariation(
                                            sigStone
                                        )
                                    "
                                    class="variation"
                                    role="option"
                                    :aria-label="
                                        getSignatureStoneLabel(sigStone)
                                    "
                                    :aria-selected="
                                        getIsActiveSignatureStoneVariation(
                                            sigStone
                                        )
                                    "
                                    @click.prevent.stop="
                                        setSignatureStone(sigStone)
                                    "
                                    @keypress.enter.prevent.stop="
                                        setSignatureStone(sigStone)
                                    "
                                >
                                    <img
                                        :alt="getSignatureStoneLabel(sigStone)"
                                        :loading="
                                            isMobileAgent ? 'lazy' : 'eager'
                                        "
                                        :src="sigStone.image"
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                </Transition>

                <DeliveryTimeframeExpress v-if="ring.supportsExpress" />

                <!-- TODO: Translate -->
                <DeliveryTimeframe
                    v-if="deliveryDate"
                    :data="deliveryDate"
                >
                    Looking for something even sooner?
                    <ThLink
                        :to="routes.readyToGoRings()"
                        class="link"
                    >
                        Browse our quick ship rings
                    </ThLink>

                    <Icon icon="angle-right" />
                </DeliveryTimeframe>

                <div class="product-cta">
                    <!-- TODO: set data-qa per cta case -->
                    <div
                        v-if="is3rdStep && !isValidCreation"
                        class="enquiry-message"
                    >
                        This combination cannot be checked out automatically.
                        Please make an enquiry.
                    </div>

                    <ThButton
                        v-qa="'button-add-to-cart'"
                        :full-width="true"
                        :loading="isActionDisabled"
                        type="solid"
                        @click="handleCta"
                    >
                        {{ ctaLabel }}
                    </ThButton>

                    <Hint v-if="!is3rdStep" />

                    <div
                        v-if="is3rdStep && isValidCreation"
                        class="customize-further"
                    >
                        <ThButton
                            v-qa="'customize-further'"
                            :full-width="true"
                            :loading="isActionDisabled"
                            type="link"
                            @click="handleCustomizeFurther"
                        >
                            <!-- TODO translate -->
                            Customise further
                        </ThButton>
                    </div>
                </div>

                <PdpAccordion
                    :items="
                        responsePage.data.value?.pageProductDetails
                            ?.accordionItems ?? []
                    "
                    about-this-entity-label="ring"
                    :resizeable="ring.isResizeable"
                    :product="ring"
                    :related-products="{
                        products: ring.relatedProducts,
                    }"
                >
                    <template #aboutThisProduct>
                        <div class="product-additional-details">
                            <div
                                v-if="ring?.translation?.seoText"
                                class="product-description"
                            >
                                <p class="description">
                                    {{ ring.translation.seoText }}
                                </p>
                            </div>

                            <ProductProperties
                                v-if="productPropertiesData"
                                :data="productPropertiesData"
                            />

                            <AccentGems
                                v-if="ring?.accentGemItems.length"
                                :accent-gems="ring.accentGemItems"
                            />
                        </div>
                    </template>
                </PdpAccordion>

                <TransitionModal>
                    <Fixed
                        v-if="isEnquiryModalOpen"
                        @close="closeEnquiryModal"
                    >
                        <ModalWithHeader
                            :label="enquiryModalTitle"
                            @close="closeEnquiryModal"
                        >
                            <EnquiryFormForm
                                :disabled="isActionDisabled"
                                :errors="errors"
                                @submit="handleModalSubmit"
                            >
                                <template #title>
                                    {{ enquiryModalTitle }}
                                </template>

                                <template
                                    v-if="enquiryType === 'add-to-cart'"
                                    #description
                                >
                                    <ul class="enquiry-description-list">
                                        <li>
                                            Save your design progress so far
                                        </li>
                                        <li>
                                            Access our expert advice and
                                            guidance
                                        </li>
                                    </ul>
                                </template>

                                <template
                                    v-if="enquiryType === 'add-to-cart'"
                                    #submit
                                >
                                    Add to cart
                                </template>
                            </EnquiryFormForm>
                        </ModalWithHeader>
                    </Fixed>
                </TransitionModal>

                <ThDialog
                    :confirm-label="'Yes'"
                    :is-open="isAddToRingBuilderDialogOpen"
                    :prompt="'Change your ring selection to this one?'"
                    @close="closeAddToRingBuilderDialog"
                    @confirm="confirmAddToRingBuilder"
                />
            </div>
        </div>

        <CmsBlocks
            :data="cmsBlocks"
            :product="ring"
            :related-products="{
                products: ring.relatedProducts,
            }"
        />

        <Reviews :data="ring.reviews" />
    </div>

    <PageErrorFourHundredFour v-else />
</template>

<script lang="ts" setup>
import {
    computed,
    defineAsyncComponent,
    hydrateOnVisible,
    ref,
    toRef,
    watch,
} from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { useHead } from '@unhead/vue'

import type {
    SignatureStoneInputFragment,
    TaxSnippetFragment,
} from '@/graphql/api'
import { useLastResponseErrorAtPath, useResponseError } from '@/helpers/errors'
import { assertNever } from '@/helpers'
import { useRoutes } from '@/router/routes'
import { useProductPageMeta } from '@/views/product/composables/useProductPageMeta'
import {
    getSignatureStoneLabel,
    useEngagementRingData,
} from './composables/useEngagementRingData'
import { useEngagementRingBreadcrumbs } from './composables/useEngagementRingBreadcrumbs'
import { useEngagementRingAddToCart } from './composables/useEngagementRingAddToCart'
import { useEngagementRing3rdStep } from './composables/useEngagementRing3rdStep'
import { useEngagementRingAnalytics } from './composables/useEngagementRingAnalytics'
import { useEngagementRingCreateShapeEnquiry } from './composables/useEngagementRingCreateShapeEnquiry'
import { useCustomerRegistrationInputStore } from '@/composables/useCustomerRegistrationInput'
import { useEngagementRingCreateEnquiry } from './composables/useEngagementRingCreateEnquiry'
import { signatureStoneToInput } from '@/domain/product/ring/engagement'
import { useRouterNavigation } from '@/plugins/released-urls/useRouterNavigation'
import { useIsMobileAgent } from '@/plugins/is-mobile-agent.ts'
import { getGenericImageProps } from '@/components/useImageProps'
import { useAbsoluteUrl } from '@/composables/app/useAbsoluteUrl'
import { useProductAnalytics } from '@/views/product/composables/analytics/useProductAnalytics'
import { useScrollIntoView } from '../composables/ui/useScrollIntoView'
import { useMoneyFormatter } from '@/plugins/money-formatter.ts'
import { useWindowScroll } from '@vueuse/core'
import { useEngagementRing3rdStepStoneModal } from '@/views/product/engagement-ring/composables/useEngagementRing3rdStepStoneModal.ts'
import { useRedirect } from 'wucdbm-vite-vue-ssr'

import MetalVariations from '@/components/rings/MetalVariations.vue'
import ThButton from '@/components/ui/buttons/ThButton.vue'
import ProductBreadcrumbs from '@/components/rings/ProductBreadcrumbs.vue'
import ThSelect from '@/components/ui/inputs/ThSelect.vue'
import TextField from '@/components/ui/inputs/TextField.vue'
import Fixed from '@/components/layout/modal/Fixed.vue'
import ModalWithHeader from '@/components/layout/modal/ModalWithHeader.vue'
import EnquiryFormForm from '@/components/enquiry/EnquiryFormForm.vue'
import Icon from '@/components/ui/icon/Icon.vue'
import TransitionModal from '@/components/layout/modal/TransitionModal.vue'
import TooltipCustom from '@/components/layout/tooltip/TooltipCustom.vue'
import DeliveryTimeframe from '@/components/rings/DeliveryTimeframe.vue'
import ThLink from '@/components/ui/buttons/ThLink.vue'
import FinanceOptions from '@/components/rings/FinanceOptions.vue'
import Image from '@/components/Image.vue'
import Money from '@/components/Money.vue'
import TaxSnippet from '@/components/rings/TaxSnippet.vue'
import ThDialog from '@/components/layout/modal/ThDialog.vue'
import ProductGallery from '@/components/layout/gallery/ProductGallery.vue'
import LazyTooltip from '@/components/layout/tooltip/LazyTooltip.vue'
import { useAuth } from '@/plugins/auth.ts'
import PageContentLoader from '@/components/ui/PageContentLoader.vue'
import { type EngagementRingProps } from '@/views/product/engagement-ring/er.ts'
import {
    useEngagementRingSize,
    useImageFor3rdStep,
    useRingBuilder,
    useRingBuilderStoneTypeLabel,
} from '@/plugins/ring-builder.ts'
import ReviewsAggregate from '@/components/rings/ReviewsAggregate.vue'
import Hint from '@/components/layout/global/Hint.vue'
import { useIsMobile } from '@/plugins/is-mobile.ts'
import SaveForLaterButton from '@/components/saved-products/SaveForLaterButton.vue'
import PdpAccordion from '@/components/product/PdpAccordion.vue'
import AccentGems from '@/components/product/AccentGems.vue'
import type { ProductPropertiesData } from '@/components/product/ProductProperties.vue'
import ProductProperties from '@/components/product/ProductProperties.vue'
import DeliveryTimeframeExpress from '@/components/rings/DeliveryTimeframeExpress.vue'

const PageErrorFiveHundred = defineAsyncComponent({
    loader: () => import('@/components/PageErrorFiveHundred.vue'),
    hydrate: hydrateOnVisible(),
})

const PageErrorFourHundredFour = defineAsyncComponent({
    loader: () => import('@/components/PageErrorFourHundredFour.vue'),
    hydrate: hydrateOnVisible(),
})

const CmsBlocks = defineAsyncComponent({
    loader: () => import('@/components/cms/CmsBlocks.vue'),
    hydrate: hydrateOnVisible(),
})

const Reviews = defineAsyncComponent({
    loader: () => import('@/components/rings/Reviews.vue'),
    hydrate: hydrateOnVisible(),
})

export type EngagementRingEnquiry =
    | 'enquiry'
    | 'add-to-cart'
    | 'shape-enquiry'
    | 'custom-enquiry'

const props = defineProps<EngagementRingProps>()

const formatter = useMoneyFormatter()

const engraving = ref('')
const engravingMaxLength = 25

const ringBuilder = useRingBuilder()

const hasEngraving = computed(() => Boolean(engraving.value.length))

const absoluteUrl = useAbsoluteUrl()
const router = useRouter()
const routes = useRoutes()
const redirect = useRedirect()

const {
    fetching,
    stale,
    ring,
    error,
    responsePage,
    cmsBlocks,
    executePageQuery,
    is3rdStep,
    isValidCreation,
    deliveryDate,
    signatureStone,
    signatureStoneOutput,
    signatureStoneLabel,
} = await useEngagementRingData(props, hasEngraving, ringBuilder)

const redirectIfNeeded = async () => {
    if (
        ring.value &&
        (ring.value.slug !== props.slug ||
            ring.value.suffixSlug !== props.suffixSlug ||
            ring.value.centreStoneConstraints.shape.systemCode !==
                props.shape ||
            ring.value.primaryMetal.systemCode !== props.metal)
    ) {
        await redirect(
            router.resolve(routes.ring.engagement(ring.value)).href,
            301
        )
    }
}

watch(ring, redirectIfNeeded)

await redirectIfNeeded()

const { loadPromise } = ringBuilder
// This is to ensure that RBuilder's data has been loaded, if any
// 1. 3rd step image
// 2. er ring size list
// 3. cta label
// Those above & others will lead to mismatch unless RB is awaited
await loadPromise

// Always use 1st step canonical URL
useHead({
    link: computed(() => {
        if (!ring.value) {
            return []
        }

        return [
            {
                rel: 'canonical',
                href: absoluteUrl(
                    router.resolve(routes.ring.engagement(ring.value))
                ).href,
            },
        ]
    }),
})

const fetchingOrStale = computed(() => fetching.value || stale.value)

const totalSalePriceBefore3rdStep = toRef(
    (): TaxSnippetFragment | undefined => {
        return signatureStoneOutput.value?.salePrice
    }
)

const {
    open: openStoneModal,
    isOpen: isStoneModalOpened,
    component: stoneModalComponent,
} = useEngagementRing3rdStepStoneModal(ringBuilder)

const ringBuilderStoneTypeLabel = useRingBuilderStoneTypeLabel()

const totalSalePrice3rdStep = ringBuilder.salePrice

const {
    addRing,
    removeRing,
    removeStone,
    ring: ringBuilderRing,
    fetchingRingBuilderSetMutation,
    stone: ringBuilderStone,
    // handleRingSizeNotSelected,
    // ringSizeError,
    // ringSizeId,
    // ringSizeOptions,
    signatureStone: rbSignatureStone,
    stoneUri: ringBuilderStoneUri,
} = ringBuilder

const imageFor3rdStep = useImageFor3rdStep()

const {
    handleRingSizeNotSelected,
    ringSizeError,
    ringSizeId,
    ringSizeOptions,
} = useEngagementRingSize()

const responseErrors = useResponseError(responsePage)

const productPropertiesData = computed<
    ProductPropertiesData | undefined | null
>(
    () =>
        ring.value && {
            title: 'Details',
            sections: [
                {
                    heading: 'Centre shape',
                    definition:
                        ring.value.centreStoneConstraints.shape.translation
                            .name,
                },
                {
                    heading: 'Metal',
                    definition: ring.value.primaryMetal.translation.name,
                },
                {
                    heading: 'Band width',
                    definition: `${ring.value.bandWidth}mm`,
                },
            ],
        }
)

const metalVariations = computed(
    () => ring.value?.variationsByPrimaryMetal || []
)
const centreStoneVariations = computed(
    () => ring.value?.variationsByCentreStoneShape || []
)

const isMobileAgent = useIsMobileAgent()

const {
    ringBuilderStoneDescription,
    ringBuilderStoneImage,
    ringBuilderRingImage,
    ringBuilderRingDescription,
    ringBuilderSignatureStoneImg,
    ringBuilderSignatureStoneDescription,
} = useEngagementRing3rdStep(ringBuilder)

const getIsActiveSignatureStoneVariation = (
    stone: SignatureStoneInputFragment
) =>
    signatureStone.value?.color === stone.color.systemCode &&
    signatureStone.value?.crystal === stone.crystal.systemCode

const getClassSignatureStoneVariation = (
    stone: SignatureStoneInputFragment
) => ({
    active: getIsActiveSignatureStoneVariation(stone),
})

const setSignatureStone = (stone: SignatureStoneInputFragment) => {
    const input = signatureStoneToInput(stone)

    signatureStone.value = input
    rbSignatureStone.value = input
}

// Add to RB
const { routerPush } = useRouterNavigation()

const isAddToRingBuilderDialogOpen = ref(false)
const openAddToRingBuilderDialog = () => {
    isAddToRingBuilderDialogOpen.value = true
}
const closeAddToRingBuilderDialog = () => {
    isAddToRingBuilderDialogOpen.value = false
}

const promptOrAddToRingBuilder = () => {
    if (
        ringBuilderRing.value &&
        ringBuilderRing.value.catalogueCode !== ring.value?.catalogueCode
    ) {
        openAddToRingBuilderDialog()
    } else {
        addToRingBuilder()
    }
}

const confirmAddToRingBuilder = () => {
    addToRingBuilder()
    closeAddToRingBuilderDialog()
}

const { scrollIntoView: scrollIntoViewStepThree } = useScrollIntoView(
    '.step-three',
    {
        left: 0,
        top: 120,
    }
)

const addToRingBuilder = () => {
    if (ring.value) {
        addRing(ring.value, signatureStone.value).then(() => {
            if (!ringBuilderStone.value || !ringBuilder.isValid.value) {
                routerPush(
                    routes.ringBuilder.recommendations('lab-grown-diamonds')
                )
            } else {
                scrollIntoViewStepThree()
            }
        })
    }
}

const isMobile = useIsMobile()
const { y } = useWindowScroll()

watch([() => props.shape, () => props.metal], () => {
    if (!isMobile.value) {
        return
    }

    y.value = 0
})

// User input
const { customerRegistrationInput } = storeToRefs(
    useCustomerRegistrationInputStore()
)

const ringBuilderIf3rdStep = computed(() =>
    is3rdStep.value ? ringBuilder : undefined
)

// Add to cart
const {
    addToCartNewCustomer,
    addToCartErrors,
    addToCartExistingCustomer,
    fetchingAddToCart,
} = useEngagementRingAddToCart(
    ring,
    ringBuilderIf3rdStep,
    ringBuilderStoneUri,
    engraving,
    customerRegistrationInput,
    handleRingSizeNotSelected
)

// Enquiry
const {
    createEnquiryExistingCustomer,
    createEnquiryNewCustomer,
    createEnquiryErrors,
    fetchingCreateEnquiry,
    createEnquiryCustomizeFurtherExistingCustomer,
    createEnquiryCustomizeFurtherNewCustomer,
} = useEngagementRingCreateEnquiry(
    ringBuilderStoneUri,
    engraving,
    customerRegistrationInput,
    handleRingSizeNotSelected
)

const handleCustomizeFurther = () => {
    if (isLogged.value) {
        createEnquiryCustomizeFurtherExistingCustomer()
    } else {
        openEnquiryModal('custom-enquiry')
    }
}

// Shape enquiry
const isEnquireShapeOpen = ref(false)

const togglesEnquireShape = () => {
    isEnquireShapeOpen.value = !isEnquireShapeOpen.value
}

const {
    createShapeEnquiryExistingCustomer,
    createShapeEnquiryNewCustomer,
    fetchingCreateShapeEnquiry,
    shapeEnquiryErrors,
} = useEngagementRingCreateShapeEnquiry(ring, customerRegistrationInput)

const handleShapeEnquiryButton = () => {
    if (isLogged.value) {
        createShapeEnquiryExistingCustomer()
    } else {
        openEnquiryModal('shape-enquiry')
    }
}

// the button should be disabled after sending a mutation but also
// when stone and ring validation is running
const isActionDisabled = computed(
    () =>
        fetchingAddToCart.value ||
        fetchingCreateEnquiry.value ||
        fetchingCreateShapeEnquiry.value ||
        fetchingRingBuilderSetMutation.value
)

const errors = useLastResponseErrorAtPath([
    ...addToCartErrors,
    ...createEnquiryErrors,
    ...shapeEnquiryErrors,
])

// Enquiry modal
const { isLogged } = useAuth()

const enquiryType = ref<EngagementRingEnquiry | null>(null)

const openEnquiryModal = (type: EngagementRingEnquiry) => {
    const ringSizeValue = handleRingSizeNotSelected()

    if (!ringSizeValue && type !== 'shape-enquiry') {
        return
    }

    enquiryType.value = type
}

const closeEnquiryModal = () => {
    enquiryType.value = null
}

const isEnquiryModalOpen = computed(() => enquiryType.value !== null)

const enquiryModalTitle = computed(() => {
    switch (enquiryType.value) {
        case 'add-to-cart':
            return 'Add to cart and:'
        // return t('enquiry.form.engagement_ring_add_to_cart.title')
        case 'enquiry':
            return t('enquiry.form.engagement_ring_enquiry_now.title')
        case 'shape-enquiry':
            return t('enquiry.form.engagement_ring.title')
        case 'custom-enquiry':
            return t('enquiry.form.engagement_ring_customize_further.title')
        case null:
            return ''
        default:
            return assertNever(enquiryType.value, '')
    }
})

// CTA button
const handleCta = () => {
    if (is3rdStep.value) {
        if (!isValidCreation.value) {
            if (isLogged.value) {
                createEnquiryExistingCustomer()
            } else {
                openEnquiryModal('enquiry')
            }
        } else {
            if (isLogged.value) {
                addToCartExistingCustomer()
            } else {
                openEnquiryModal('add-to-cart')
            }
        }
    } else {
        promptOrAddToRingBuilder()
    }
}

// TODO translate
const ctaLabel = computed(() => {
    if (is3rdStep.value) {
        if (!isValidCreation.value) {
            return 'Enquire now'
        }

        return 'Add to Cart'
    } else {
        return ringBuilderStone.value
            ? 'Next: Personalise your ring'
            : 'Next: Choose your gem'
    }
})

const handleModalSubmit = () => {
    switch (enquiryType.value) {
        case 'shape-enquiry':
            createShapeEnquiryNewCustomer()
            break
        case 'add-to-cart':
            addToCartNewCustomer()
            break
        case 'enquiry':
            createEnquiryNewCustomer()
            break
        case 'custom-enquiry':
            createEnquiryCustomizeFurtherNewCustomer()
            break
        case null:
            break
        default:
            assertNever(enquiryType.value, enquiryType.value)
    }
}

const classStepThree = computed(() => ({
    fetching: fetchingRingBuilderSetMutation.value,
}))

// Misc
const breadcrumbs = useEngagementRingBreadcrumbs(ring)

useProductPageMeta(
    computed(() => responsePage.data.value?.pageProductDetails?.meta),
    ring,
    fetchingOrStale,
    stale,
    ringBuilderIf3rdStep
)

useEngagementRingAnalytics(is3rdStep, ring, ringBuilderStone, fetchingOrStale)

useProductAnalytics(ring, fetching, ringBuilderIf3rdStep)

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.product-additional-details {
    .description {
        font-size: 1rem;
        line-height: 1.6em;
        padding: 0 0 20px;
    }
}

.price-explained-text {
    :deep(.tooltip-trigger) {
        &:after {
            font-size: 1rem;
            margin-left: 1px;
        }
    }
}

.price-explainer-list {
    padding: 10px 15px;

    @include min-width(640) {
        padding: 0;
    }

    .item {
        margin-bottom: 15px;

        @include min-width(640) {
            display: flex;
            justify-content: space-between;
        }

        .label {
            display: block;
            margin-bottom: 5px;
        }

        .value {
            display: block;
        }
    }

    .divider {
        @include border-bottom;

        margin-bottom: 15px;
    }
}

.product-wrapper {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto 20px;
    padding: 0 20px;

    @include fetching;

    @include min-width(768) {
        padding: 0 10px;
        display: flex;
        align-items: flex-start;
    }

    @include min-width(1440) {
        padding: 0;
    }

    .product-details {
        width: 100%;
        margin: 40px auto 0;
        max-width: 480px;

        @include min-width(768) {
            margin: 0 auto;
            max-width: 375px;
            padding: 0 10px 0 30px;
        }

        @include min-width(1024) {
            margin: 0 40px;
            padding: 0;
        }

        @include min-width(1280) {
            margin: 0 80px;
        }

        @include min-width(1440) {
            margin: 0 100px;
        }

        .product-information {
            padding: 0 0 25px;
            margin: 0 0 25px;
            @include border-bottom;

            .product-title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 0 0 10px 0;

                .name {
                    font-family: $parcel-font-stack;
                    font-size: 1.5rem;
                    line-height: 1.25em;

                    @include min-width(768) {
                        font-size: 2rem;
                    }
                }
            }

            .description {
                display: block;
                margin: 0 0 35px;
            }

            .price {
                font-size: 1.5rem;
                line-height: 1.25em;
                font-family: $parcel-font-stack;
                display: block;
                margin: 0 0 15px;
            }

            .price-excludes,
            .price-explained,
            .finance-options {
                display: flex;
                margin: 0 0 15px;
            }

            .step-three {
                position: relative;
                max-height: 500px;

                &.fetching {
                    @include fetching;
                }

                .title {
                    padding: 16px 0;
                    @include border-bottom;
                }

                .item {
                    margin: 16px 0;
                    display: flex;
                    align-items: center;
                    text-transform: capitalize;

                    &.ring,
                    &.stone {
                        .image {
                            margin-right: 8px;
                            width: 32px;
                            height: 32px;
                        }
                    }

                    &.stone .image {
                        padding: 4px;
                    }

                    &.signature-stone {
                        justify-content: flex-start;
                    }

                    .icon-stone-modal-info {
                        margin-left: 5px;
                        cursor: pointer;

                        &:before {
                            width: 22px;
                            height: 22px;
                            font-size: 18px;
                            line-height: 22px;
                            color: $blue;
                        }
                    }

                    .remove-button {
                        margin-left: auto;
                        height: 24px;
                        flex: 0 0 24px;
                        font-size: 12px;
                        color: $grey-500;
                        cursor: pointer;
                        border-radius: 50%;
                        background-color: $grey-200;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        user-select: none;
                    }
                }

                .size-and-engraving {
                    margin-top: 24px;

                    @include min-width(640) {
                        display: flex;
                    }

                    .size {
                        @include min-width(640) {
                            width: 200px;
                        }
                    }

                    .engraving {
                        margin-top: 24px;

                        @include min-width(640) {
                            margin: 0 0 0 20px;
                        }
                    }
                }
            }
        }

        .product-customization {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            flex-wrap: wrap;
            max-height: 500px;

            .product-variation {
                width: 100%;
                @include border-bottom;

                padding: 0 0 15px;
                margin: 0 0 25px;

                .label {
                    display: flex;
                    font-size: 14px;
                    line-height: 1em;
                    margin: 0 0 15px;
                    align-items: center;

                    .additional-options {
                        margin-left: auto;
                        text-decoration: underline;
                        cursor: pointer;
                    }

                    :deep(.tooltip-trigger) {
                        &:after {
                            line-height: 1rem;
                            font-size: 1rem;
                            margin-left: 5px;
                        }
                    }
                }

                .shape-variations {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;

                    .variation {
                        margin: 0 10px 10px 0;
                        flex-shrink: 0;

                        .link {
                            display: block;

                            .image {
                                object-fit: contain;
                                width: 28px;
                                height: 28px;
                                opacity: 0.4;
                            }

                            &.router-link-active {
                                border-bottom: 1px solid rgba($blue, 0.5);

                                .image {
                                    filter: invert(26%) sepia(59%)
                                        saturate(622%) hue-rotate(179deg)
                                        brightness(91%) contrast(84%);
                                    opacity: 1;
                                }
                            }

                            .name {
                                width: 28px;
                                height: 28px;
                                background: $grey-200;
                                border-radius: 50%;
                                display: block;
                                font-size: 0;
                            }
                        }
                    }
                }

                .enquire-shape {
                    background: $blue;
                    color: $white;
                    padding: 20px 20px 25px;
                    position: relative;
                    font-size: 0.875rem;

                    .th-button {
                        margin: 15px 0 0;
                    }

                    .title {
                        font-size: 1.125rem;
                        display: block;
                        margin: 0 50px 20px 0;
                    }

                    .enquire-shape-close {
                        cursor: pointer;
                        width: 40px;
                        height: 40px;
                        position: absolute;
                        top: 10px;
                        right: 5px;
                        text-align: center;
                        line-height: 40px;
                    }
                }

                .metal-variations {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    margin: 0 0 10px;

                    .variation {
                        width: 28px;
                        height: 28px;
                        margin: 0 10px 0 0;

                        .link {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                            background: #c8c8c8;
                            font-size: 0;
                            display: block;

                            &.router-link-active {
                                border: 1px solid $blue;
                                box-shadow: inset 0 0 0 3px $white;
                            }
                        }
                    }
                }

                .signature-stone-variations {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    margin: 0 0 10px;

                    .variation {
                        width: 28px;
                        height: 28px;
                        margin: 0 10px 10px 0;
                        position: relative;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 85%;
                            height: 85%;
                        }

                        &.active {
                            &:before {
                                content: '';
                                height: 0;
                                border-bottom: 1px solid $blue;
                                display: block;
                                bottom: -5px;
                                left: 0;
                                right: 0;
                                margin: 0 auto;
                                position: absolute;
                            }

                            img {
                                width: 95%;
                                height: 95%;
                            }
                        }
                    }
                }
            }
        }

        .product-cta {
            padding: 0 0 25px;
            margin: 0 0 25px;

            .enquiry-message {
                background: $stone-2;
                display: block;
                padding: 15px 20px;
                margin: 0 0 20px;
                font-size: 0.875rem;
            }
        }

        .customize-further {
            margin-top: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.product-customization-enter-active,
.product-customization-leave-active,
.step-three-enter-active,
.step-three-leave-active {
    transition: all 0.45s ease;
    overflow-y: hidden;
}

.price-explained-container {
    :deep(.tooltip-trigger) {
        display: inline-flex;
    }
}

.product-customization-enter-from,
.product-customization-leave-to,
.step-three-enter-from,
.step-three-leave-to {
    max-height: 0 !important;
    opacity: 0;
    overflow-y: hidden;
}

:deep(.enquiry-form-form) {
    .form-header {
        max-width: 380px;
        margin: 0;
        padding: 0 20px 20px;

        .form-title {
            text-align: left;
        }
    }
}

.enquiry-description-list {
    text-align: left;
    list-style: disc outside none;
    padding: 0 0 0 20px;
}
</style>
